import React, { useEffect, useState } from 'react'
import { Col, Row, FormGroup, Input, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const NutSeedButtersNutritionReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    Iron: item.Iron,
    Protein: item.Protein,
  })

  const methods = useFormContext()
  const { onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { Iron, Protein } = item
      setPackaging({ Iron, Protein })
    }
    // eslint-disable-next-line
  }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Iron (mg) per 2 tablespoons (32g) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              type="number"
              step="0.01"
              name="Iron"
              defaultValue={packaging.Iron}
              onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
              control={methods.control}
              rules={{
                required: '⚠ Please enter Iron (mg) per 2 tablespoons (32g)',
                maxLength: {
                  value: 6,
                  message: '⚠ Iron (mg) per 2 tablespoons (32g) exceeds 6 characters',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="Iron"
              as={<Alert color="danger" className="mt-3" />}
            />
          </FormGroup>
        </Col>

        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Protein (g) per 2 tablespoons (32g) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              type="number"
              step="0.01"
              name="Protein"
              defaultValue={packaging.Protein}
              onKeyDown={e => isNotNumericDecimal(e.key) && e.preventDefault()}
              control={methods.control}
              rules={{
                required: '⚠ Please enter Protein (g) per 2 tablespoons (32g)',
                maxLength: {
                  value: 4,
                  message: '⚠ Protein (g) per 2 tablespoons (32g) exceeds 4 characters',
                },
                pattern: {
                  value: /^\d+(\.\d{1,2})?$/,
                  message: '⚠ Maximum two decimal places allowed.',
                },
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <ErrorMessage
              errors={methods.errors}
              name="Protein"
              as={<Alert color="danger" className="mt-3" />}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

NutSeedButtersNutritionReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default NutSeedButtersNutritionReview
